import React from 'react';
import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { connect } from 'react-redux';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage, defineMessages } from 'react-intl';
import { SimpleLoadingComponent } from '../../utils/apollo';

import './styles.css';
import PageTitle from '../../components/PageTitle';
import Header from '../../components/Header';
import * as constants from '../Authorization/constants';
import Menu from '../../components/Menu';

const messages = defineMessages({
  'change-profile': {
    id: 'settings.menu.accountInfo',
    defaultMessage: 'Account Information',
  },
  'your-notifications': {
    id: 'settings.menu.your-notifications',
    defaultMessage: 'Your Notifications',
  },
  'institution-notifications': {
    id: 'settings.menu.institution-notifications',
    defaultMessage: 'Institution Notifications',
  },
  'manageUsers': {
    id: 'settings.menu.manageUsers',
    defaultMessage: 'Users',
  },
  'sftp-settings': {
    id: 'settings.menu.sftp-settings',
    defaultMessage: 'SFTP Data Transfer',
  },
});

export class IntersectSettingsPage extends React.PureComponent {
  static propTypes = {
    currentViewer: PropTypes.object,
    viewer: PropTypes.object,
    router: PropTypes.object,
    route: PropTypes.object,
    children: PropTypes.object,
  };

  hasSubscription(requiredSubscription) {
    const { viewer } = this.props;
    const subscriptions = get(viewer, 'heAccount.activeSubscriptions');
    return subscriptions && subscriptions.includes(requiredSubscription);
  }

  hasAnySubscription(requiredList) {
    const { viewer } = this.props;
    const subscriptions = get(viewer, 'heAccount.activeSubscriptions');
    return subscriptions && requiredList.some((requiredSubscription) => subscriptions.includes(requiredSubscription));
  }

  hasFeatureEnabled(requiredFeature) {
    const { viewer } = this.props;
    return viewer.enabledFeatures.includes(requiredFeature);
  }

  isAdmin() {
    const { currentViewer } = this.props;
    return (get(currentViewer, 'idToken["custom:role"]') === constants.ADMIN_ROLE);
  }

  filterRequiredSubscription = ({ requiredSubscription }) => {
    if (Array.isArray(requiredSubscription)) {
      return this.hasAnySubscription(requiredSubscription);
    }
    return !requiredSubscription || this.hasSubscription(requiredSubscription);
  }

  render() {
    const { route, children, router } = this.props;
    return (
      <div styleName="container" id="content">
        <PageTitle title="Settings" category="Intersect" />
        <Header as="h1" id="right-side-heading">
          <FormattedMessage id="settings.header" defaultMessage="Settings" />
        </Header>
        <div styleName="pageContainer">
          <section aria-labelledby="right-side-heading">
            <nav aria-label="Settings Side Menu">
              <Menu as="ul" vertical className="third">
                {route && route.childRoutes && route.childRoutes
                  .filter(({ requiresAdmin }) => !requiresAdmin || this.isAdmin())
                  .filter(this.filterRequiredSubscription)
                  .filter(({ requiredFeature }) => !requiredFeature || this.hasFeatureEnabled(requiredFeature))
                  .map(({ path }) =>
                    (
                      <Menu.Item key={path} as="li">
                        <Link
                          to={`/settings/${path}`}
                          className="menu-link"
                          activeClassName="active"
                          aria-current={router.location.pathname.includes(path) ? 'true' : 'false'}
                          aria-label={messages[path].defaultMessage}
                        >
                          <FormattedMessage {...messages[path]} />
                        </Link>
                      </Menu.Item>
                    ))}
              </Menu>
            </nav>
          </section>
          <section aria-labelledby="pageTitle" styleName="pageContent">
            {children}
          </section>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentViewer: get(state, 'current.viewer'),
});
export const reduxContainer = connect(mapStateToProps, {})(IntersectSettingsPage);

const query = gql`
  query IntersectSettingsPage {
    viewer {
      id
      enabledFeatures
      heAccount {
        id
        activeSubscriptions
      }
    }
  }
`;
export default SimpleLoadingComponent(graphql(query))(reduxContainer);
